import {Toolbar,Grid} from '@mui/material';
import atlasLogo from '../../Assets/images/AtlasLogo.png';
import niarLogo from '../../Assets/images/NIARLogo.png';
import atlasName from '../../Assets/images/ATLASName.png';
import './styles.css';
import fppVideo from '../../Assets/videos/FPP-cell-video.mp4';
import tpwVideo from '../../Assets/videos/TPWVideo.mov';
import frankensteinVideo from '../../Assets/videos/NPEVideo.mp4';
import awpVideo from '../../Assets/videos/AWPVideo.mp4';
import hasmVideo from '../../Assets/videos/SCRAM-Hyperlapse.mp4'

const link = (title) => {
    switch (title) {
        case 'Frankenstein (FS-19)':
            return frankensteinVideo;
        case 'Thermoplastic Welding':
            return tpwVideo;
        case 'Fiber Patch Placement':
            return fppVideo;
        case 'Aircraft Window Plug':
            return awpVideo;
        case 'Hybrid Additive and Subtractive Manufacturing':
            return hasmVideo;
        default:
            console.error("Couldnt find video")
            return fppVideo;
    }
}


const TopBar = () => {
    return(
        <Toolbar sx={{
            backgroundColor: '#27251F',
            position: 'absolute',
            top: 0,
            height: '8vh',
            width: '100vw',
            justifyContent: 'space-between',
            boxShadow: 6,
        }}>
            <img 
                src={niarLogo} 
                alt='niarLogo'
                style={{
                height: '8vh',
                marginLeft: '1vh',
                marginTop: '1vh'}}
            />

            <div className='yellowBoxBar'>
                <img 
                    src={atlasName} 
                    alt='atlasName'
                    style={{
                    position: 'absolute',
                    top: '50%', // Position vertically centered
                    left: '5%', // Distance from the left edge of the box
                    transform: 'translateY(-50%)', // Center the image vertically
                    width: '40%', 
                    objectFit: 'cover', 
                }}
                />
                <img 
                    src={atlasLogo} 
                    alt='atlasLogo'
                    style={{
                        position: 'absolute',
                        top: '50%', // Position vertically centered
                        right: '5%', // Distance from the right edge of the box
                        transform: 'translateY(-50%)', // Center the image vertically
                        height: '90%', 
                        objectFit: 'cover', 
                    }}
                />
            </div>
        </Toolbar>
    );
}

const TitlePage = ({ title, subtitle }) => {
    return(
        <div>
            <div className='video'>
                <video 
                    autoPlay 
                    loop 
                    muted
                    playsInline
                    src={link(title)}
                    type='video/mp4'
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
            </div>
            <div className='titleContainer'>
                <div className='title'>
                    <h1 id="projectInfoTitle">{title}</h1>
                </div>
                <div className='subtitle'>
                 <h2 id="projectInfoSubtitle">{subtitle}</h2>
                </div> 
                </div>
            </div>
        
    )
}

const InfoCard = ({ title, array }) => {
  const listArr = array?.map(( item, index) => (
        <li key={index} id="projectInfoList">{item}</li>
    ));
     return (
    <div className='infoCard'>
        <div className='infoHeading'>
            <h3 id="projectInfoHeading">{title}</h3>
        </div>
        <div className='infoList'>
            <ul style={{listStyleType: 'disc'}}>
                {listArr}
            </ul>
        </div>
    </div>
     );
};


export default function ProjectInfoPage({ props }) {
    console.log(props)
    return(
        <div className='mainPage'>
                <TopBar />
                <TitlePage title={props.title} subtitle={props.subtitle} />
                <Grid
                    container
                    spacing={props.keyFacts.length > 0 ? 2 : 1}
                    justifyContent="space-around"
                    paddingBottom="90px"
                >
                    <Grid item xs={8} md={5} >
                        <InfoCard title={props.title === 'Frankenstein (FS-19)' ? 'Development of Cost Models' : 'Benefits'} array={props.benefits} />
                    </Grid>
                    <Grid item xs={8} md={5} >
                        {props.keyFacts.length !== 0 ? <InfoCard title='Key Facts' array={props.keyFacts} /> : null}
                    </Grid>
                </Grid>
        </div>
    );
}



